import { render } from "./SegmentedBar.vue?vue&type=template&id=0224d7ca&scoped=true"
import script from "./SegmentedBar.vue?vue&type=script&lang=js"
export * from "./SegmentedBar.vue?vue&type=script&lang=js"

import "./SegmentedBar.vue?vue&type=style&index=0&id=0224d7ca&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0224d7ca"]])

export default __exports__